module.exports = __webpack_public_path__ + "img/a3.caac2a4e.jpg";